__turbopack_context__.v({
  "button": "button-module__OJPZRa__button",
  "centerLabel": "button-module__OJPZRa__centerLabel",
  "danger": "button-module__OJPZRa__danger",
  "disabled": "button-module__OJPZRa__disabled",
  "large": "button-module__OJPZRa__large",
  "primary": "button-module__OJPZRa__primary",
  "secondary": "button-module__OJPZRa__secondary",
});
